import React from 'react';
import PropTypes from 'prop-types';

export default function ProgressColumn(props) {
  const { points: rawPoints, scoreTarget: rawScoreTarget } = props;

  const points = rawPoints < 0 ? 0 : rawPoints;
  const scoreTarget = rawScoreTarget || 0;
  const progress = ((points / scoreTarget) * 100).toFixed(2);

  return (
    <div className="progress-column">
      <div className="progress-container">
        <div className="progress-bar">
          <span style={{ width: `${progress > 100 ? 100 : progress}%` }} />
        </div>
        <span className="progress-number">{`${progress}%`}</span>
      </div>
    </div>
  );
}

ProgressColumn.propTypes = {
  points: PropTypes.number.isRequired,
  scoreTarget: PropTypes.string.isRequired,
};
